import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import { FETCH_ROLES, FETCH_ROLE, ROLE_CREATE, FETCH_ERROR } from './actions.type'
import { SET_ROLES, SET_ROLES_ERRORS, SET_ROLES_LOADING, SET_ROLE, SET_ROLE_ERRORS, SET_ROLE_LOADING } from './mutations.type'

const state = {
	roles: [],
	rolesErrors: [],	
	rolesIsLoading: false,
	role: null,
	roleErrors: [],	
	roleIsLoading: false
}

const getters = {
	roles : state => group => key => {
		return state.roles.filter(x => {
			if (x.dn.includes(group)) {
				if (x.cn && x.cn.toLowerCase().includes(key.toLowerCase())) {
					return true
				}
				if (x.description && x.description.toLowerCase().includes(key.toLowerCase())) {
					return true
				}
				return false
			}
			return false
		}).sort(function(a, b) {
			if (a.description < b.description) return -1
			if (a.description > b.description) return 1
			return 0
		})
	},
	rolesErrors (state) {
		return state.rolesErrors
	},
	rolesIsLoading (state) {
		return state.rolesIsLoading
	},
	role (state) {
		return state.role
	},
	roleErrors (state) {
		return state.roleErrors
	},
	roleIsLoading (state) {
		return state.roleIsLoading
	}
}

const actions = {
	[FETCH_ROLES] (context, params) {
		context.commit(SET_ROLES_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.query('manager/groups')
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_ROLES, data)
					resolve(data)
				} else {
					context.commit(SET_ROLES_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_ROLES_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_ROLES_LOADING, false)
			})
		})
	},
	[FETCH_ROLE] (context, params) {
		context.commit(SET_ROLE_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.get(`manager/groups/${params.dn}`)
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_ROLE, data)
					resolve(data)
				} else {
					context.commit(SET_ROLE_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_ROLE_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_ROLE_LOADING, false)
			})
		})
	},
	[ROLE_CREATE] (context, params) {
		return new Promise((resolve, reject) => {
			ApiService.post('manager/groups/', params)
			.then(({data}) => {
				if (data === true) {
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Роль создана", title: "Готово" })
				} else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось создать роль" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось создать роль" })
				ErrorsService.setFetchError(SET_ROLE_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_ROLE_LOADING, false)
			})
		})
	}
}

const mutations = {
	[SET_ROLES] (state, data) {
		state.roles = data
		state.rolesErrors = []
	},
	[SET_ROLES_ERRORS] (state, errors) {
		state.roles = []
		state.rolesErrors = errors
	},
	[SET_ROLES_LOADING] (state, status = true) {
		state.rolesIsLoading = status
	},
	[SET_ROLE] (state, data) {
		state.role = data
		state.roleErrors = []
	},
	[SET_ROLE_ERRORS] (state, errors) {
		state.role = null
		state.roleErrors = errors
	},
	[SET_ROLE_LOADING] (state, status = true) {
		state.roleIsLoading = status
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/roles.module.js